import React, { useEffect, useRef, useState } from "react";
import { width, height } from "../../CustomComponents/Card/CardStyles";
import { useTranslation } from "react-i18next";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useDispatch, useSelector } from "react-redux";
import right_dropdown_arrow from "../../../assets/images/right_dropdown_arrow.png";
import CustomTextInput from "../../CustomComponents/CustomtextInput";
import Loader from "../../CustomComponents/Loader";
import Modal from "../../CustomComponents/Modal";
import {
  GetApiHeadersWithBearer,
  GetRequest,
  PostRequest,
} from "../../../network/NetworkUtils";
import { useNavigate, Link } from "react-router-dom";
import {
  appTheme,
  fetchConfigarationData,
  retrieveData,
} from "../../../helpers/utils/Utils";
import CustomAlertModel from "../../CustomComponents/CustomAlertModel";
import { withOidcSecure } from "@axa-fr/react-oidc";
import Footer from "../../Layout/Footer";
import HomeLayout from "../../Layout/HomeLayout";
import HomeHeader from "../../CustomComponents/HomeHeader";
import DynamicCard from "../../CustomComponents/DynamicHomeCard";
import { useKeyDown } from "../../../hooks/useKeyDown";
import statement_page from "../../../assets/images/statement_page.png";
import shredding_statement from "../../../assets/images/shredding_statement.png";
import Bell from "../../../assets/images/Bell.png";
import LeftBar from "../../CustomComponents/DynamicComponent/LeftBar";
import arrow from "../../../assets/images/Caret_S.png";
import HtmlDropDown from "../../CustomComponents/HtmlDropDown";
import { AGREEMENTS, STATUS_SUCCESS_CODE } from "../../../network/URLConstants";
import HtmlNavigation from "../../CustomComponents/HtmlNavigation";
import CardHeading from "../../CustomComponents/CardHeading";
import { getUserMembership } from "../../../helpers/utils/Utils";
import FooterContent from "../../CustomComponents/Footer";
import logFirebaseEvents from "../../LogFirebaseEvents";
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';

// Policy changes

const KudzuDocumentOptions = () => {
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);
    const { t } = useTranslation();    
    useDocumentTitle(t('page_title_kudzu_documents'));

  const [height, setHeight] = useState(0);
  const cards = useSelector((state) => JSON.parse(state.userCards));
  const [isOTPVerifyModalOpen, setIsOTPVerifyModalOpen] = useState(false);
  const [isMobileVerificationModalOpen, setisMobileVerificationModalOpen] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [showModel, setShowModel] = useState(false);
  const [modelImage, setModelImage] = useState("");
  const [highlightMsg, setHighlightMsg] = useState("");
  const [headerMsg, setheaderMsg] = useState("");
  const [subHeaderMsg, setSubHeaderMsg] = useState("");
  const [btn1Exists, setBtn1Exists] = useState(false);
  const [btn2Exists, setBtn2Exists] = useState(false);
  const [btn1Text, setBtn1Text] = useState(false);
  const [btn2Text, setBtn2Text] = useState("");
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false);
  const [type, setType] = useState("");
  const [footerMsg, setFooterMsg] = useState("");
  const [displayContent, setDisplayContent] = useState({});
  const [accountType, setAccountType] = useState({});
  const isSmiOneIsTrue = useSelector((state) => state.smiOneAccountTrue);
  const loggedResponse = useSelector((state) =>
    JSON.parse(state.loggedInResponse)
  );
  const userMembershipData = getUserMembership(loggedResponse);

  const [toNavigate, setToNavigate] = useState("");
  const [isBorderNone, setisBorderNone] = useState(true);
  const [showErrorImg, setshowErrorImg] = useState(false);
   const dispatch = useDispatch();
  const documentsChildren1 = () => {
    return (
      <>
        <div className="sm:flex block flex-row justify-between md:pt-20 pt-16 sm:pt-12 lg:pb-36 md:pb-32 sm:pb-24 pb-28 md:mx-0 mx-4">
          <div className="flex flex-col lg:w-[406px] md:w-[321px] sm:w-[300px] w-[263px]">
            <p
              className="text-[var(--documentDemand-clr)] font-normal 
                        leading-[30px] md:leading-[24px] lg:text-[32px]
                         md:text-[28px] text-[25px] lg:leading-[38px] sm:text-[18px] sm:leading-[24px]
                          font-serif-pro w-[70%] sm:w-full"
            >
              {t("documents_on_demand")}
            </p>

            <p
              className="font-hanken-grotesk font-[400] sm:font-[500] md:leading-[30px] 
                        sm:leading-[20px] leading-[20px]  md:text-[20px] sm:text-[12px] 
                         text-[14px] md:mt-6 mt-4 text-[var(--documentAcess-clr)]
                        "
            >
              {t("access_your_documents_online_or_via_your_kudzu")}
            </p>
          </div>
          <div className="sm:block flex justify-center sm:mt-0 mt-28">
            <img
              src={appThemeData.kudzu_statementsIcon}
              alt="setting"
              className=" lg:h-[120px] lg:w-[120px]
                         sm:h-[92px] sm:w-[92px] 
                         h-[120px] w-[120px]"
            />
          </div>
        </div>
      </>
    );
  };

  const footerContent = () => {
    return (
      <FooterContent
        highlightText={t("access_your_bankstatements_at_any_time")}
        subHeaderText={t("easily_view_and_download_any_of_your_past")}
        image={appThemeData.kudzu_Document_Footer_Icon}
        buttonEnabled={true}
        isSpace={true}
        buttonText={t("view_statements")}
        footerBtnAction={() => {

          dispatch({ type: 'KUDZU_STATEMENT_SELECT', payload:{kudzuStatementSelected:true} });

          dispatch({ type: 'SMI_STATEMENT_SELECT', payload: {smiStatementSelected:false} });
          navigate("/Documents/Statements");
        }}
        type={"FindATM"}
        isSubheadingwidth={true}
        highlightTextColor={"#2965FB"}
      />
    );
  };

  useKeyDown(() => {}, ["Enter"]);

  const leftBarComp = () => {
    return (
      <>
        <div className="lg:w-[260px] md:w-[183px] sm:w-[164px] w-full sm:mx-0 ml-[2.5rem]">
          <p
            className="text-white font-normal
                    lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px]
                    sm:leading-[30px] leading-[31px]
          font-serif-pro sm:border-b-[2.5px] sm:border-[#4B70B9] lg:pb-14 md:pb-[50px]  sm:border-opacity-[50%]
          sm:pb-[2.6rem] pb-[2.6rem] mb-10"
          >
            {t("easily_access_policy")}
          </p>
          <div className="flex flex-col gap-4 text-white w-[80%]">
            {/* smiONE Navigation */}
            <Link
              to="/Documents/smiONE"
              className="text-white font-bold text-[16px] cursor-pointer hover:opacity-80 active:opacity-80 transition-opacity"
            >
              {"smiONE"}
            </Link>
          </div>
          <div className="flex pt-4 flex-col gap-4 text-white w-[80%]">
            {/* Kudzu Navigation (Current Page) */}
            <Link
              to="/Documents/Kudzu"
              className="text-[#94C3E8] font-bold text-[16px] cursor-pointer hover:opacity-80 active:opacity-80 transition-opacity"
            >
              {"Kudzu"}
            </Link>
            <div className="flex flex-col gap-2 ml-5 transition-all duration-300 ease-in-out">
              {/* Statements */}
              {cards?.[0]?.EnableStatements && (
                <Link
                  to="/Documents/Kudzu/Statements"
                  className="pb-2 cursor-pointer hover:opacity-80 active:opacity-80 transition-opacity"
                  onClick={() => {
                    logFirebaseEvents(
                      "Documents",
                      "Statement_Clicked",
                      "Statement_Clicked",
                      "",
                      ""
                    );
                  }}
                >
                  <p className="font-hanken-grotesk font-semibold text-[15px] text-[#FEFAEE]">
                    {t("KUDZU_Statements")}
                  </p>
                </Link>
              )}

              {/* Policies Dropdown */}
              <div className="flex flex-col gap-6">
                <Link
                  to="/Documents/Kudzu/Policies"
                  className="font-hanken-grotesk font-semibold text-[15px] text-[#FEFAEE] cursor-pointer hover:opacity-80 active:opacity-80 transition-opacity"
                >
                  {t("KUDZU_Policies")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <HomeLayout>
      <LeftBar leftBarType="component" leftBarComp={leftBarComp()} />
      <div className="md:w-[150px] sm:w-[70px] w-[0px]"></div>

      <div
        className="flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] 
                animate__animated animate__fadeInRight "
      >
        <DynamicCard
          header={false}
          CardRadius={true}
          cardWidth={width.allpolicies}
          HeaderRadius={true}
          backgroundColor={"pink"}
          isWhite={appThemeData.isWhiteBgForCard}
          isDarkForKudzu={appThemeData.isDarkBgForCard}
          HeaderContent={false}
        >
          {documentsChildren1()}
        </DynamicCard>
        {footerContent()}
        {loading && <Loader />}
      </div>
    </HomeLayout>
  );
};

export default withOidcSecure(KudzuDocumentOptions);
